















import Vue, { PropType } from 'vue'
import { Specification } from '~/models/classified/types'
import { mapGetters, mapState } from 'vuex'
import { CLASSIFIED_VIEW_NS } from '~/store/modules/shared/classifieds/view/state'
import { mapDeps } from '~/plugins/dependency-container/utils'
import ScrollService from '~/services/scroll/ScrollService'
import CPrice from '~/components/shared/configurable/CPrice.vue'

export default Vue.extend({
  components: {
    CPrice
  },
  props: {
    specification: {
      type: Object as PropType<Specification>,
      required: true
    }
  },
  computed: {
    ...mapState(CLASSIFIED_VIEW_NS, {
      option: state => state.leasing.option,
      withVat: state => state.leasing.withVat
    }),
    ...mapGetters(CLASSIFIED_VIEW_NS, {
      getLeasingOptionFieldVatValue: 'getLeasingOptionFieldVatValue'
    }),
    ...mapDeps({
      scrollService: ScrollService
    })
  },
  methods: {
    handleValueClick() {
      const financePartial = document.getElementById('financePartial')
      if (financePartial) {
        this.scrollService.scrollTo(financePartial, {
          easing: 'ease-out',
          offset: -30,
          duration: 500
        })
      }
    }
  }
})
